/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { LogoWrapper } from "../../../headers/header-helper-components";
import { SignInScreen } from "../sign-in/signin-screen";
import { SignUpScreen } from "../sign-up/signup-screen";
import { ForgotPasswordScreen } from "../forgot-password/forgot-password-screen";
import { MobileOtpScreen } from "../sign-in/otp-screen";
import { EmailOtpScreen } from "../sign-up/otp-screen";
import { ResetPasswordScreen } from "../forgot-password/reset-password-screen";
import { PasswordScreen } from "../sign-in/password-screen";
import { useSelector } from "react-redux";
import { getDarkModeStyle } from "../util";
import "./user-login.module.css";
import { get } from "lodash";

const RenderScreen = () => {
  const { currentScreen = "signIn" } = useSelector((state) => get(state, ["login", "singleSignOn"], {}));
  const mode = getDarkModeStyle();

  switch (currentScreen) {
    case "signUp":
      return <SignUpScreen mode={mode} isUserLoginPage={true} />;
    case "mobileOtp":
      return <MobileOtpScreen mode={mode} isUserLoginPage={true} />;
    case "emailOtp":
      return <EmailOtpScreen mode={mode} isUserLoginPage={true} />;
    case "password":
      return <PasswordScreen mode={mode} isUserLoginPage={true} />;
    case "forgotPassword":
      return <ForgotPasswordScreen mode={mode} isUserLoginPage={true} />;
    case "resetPassword":
      return <ResetPasswordScreen mode={mode} isUserLoginPage={true} />;
    default:
    case "signIn":
      return <SignInScreen mode={mode} isUserLoginPage={true} />;
  }
};

export const UserLogin = () => {
  const { logoUrl = "", logo = "" } = useSelector((state) =>
    get(state, ["qt", "config", "pagebuilder-config", "header"], {})
  );

  return (
    <div styleName="container-wrapper">
      <LogoWrapper logoUrl={logoUrl} headerSecondaryLogo={logo} />
      <RenderScreen />
    </div>
  );
};
